import { SessionStore } from '/global-state';

/**
 * Common properties for a Site object from `/dashboard_scope` and `/sites`
 */
type SiteCommon = {
  token: string;
  name: string;
  site_id: string;
};

const getSessionSites = () => {
  const session = SessionStore.getCurrentState().session;

  return session
    ? session.sites.map((site): SiteCommon => ({ site_id: site.site_id, token: site.token, name: site.name }))
    : undefined;
};

export function siteIdToToken(
  siteId?: string,
  sites: SiteCommon[] | undefined = getSessionSites(),
): string | undefined {
  return siteId ? sites?.find((site) => site.site_id === siteId)?.token : undefined;
}

export function siteTokenToId(
  siteToken?: string,
  sites: SiteCommon[] | undefined = getSessionSites(),
): string | undefined {
  return siteToken ? sites?.find((site) => site.token === siteToken)?.site_id : undefined;
}
